import { render } from "./global-search-popup.vue?vue&type=template&id=70805b1c"
import script from "./global-search-popup.vue?vue&type=script&lang=js"
export * from "./global-search-popup.vue?vue&type=script&lang=js"
script.render = render

export default script